module.exports = __webpack_public_path__ + "img/gastos.db06c15f.png";